import { Grid } from "@mui/material";
import React from "react";

import Login from "../Elements/Login";

export function Home() {
  function render() {
    return (
      <div>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid size={12} align="center">
            <img src="/atlantis.png" alt="" style={{ maxWidth: "100%" }} />
          </Grid>
          <Grid size={{ xs: 12, sm: 9, md: 6, lg: 4 }}>
            <Login />
          </Grid>
        </Grid>
      </div>
    );
  }

  return render();
}
